<template>
    <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900">Board products</h3>
                <p class="mt-1 text-sm leading-5 text-gray-600">
                    Job listing paid upgrades
                </p>
            </div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
                <form @submit.prevent="submit">
                    <div class="px-4 py-5 bg-white sm:p-6">
                        <div class="grid grid-cols-3 gap-6">
                            <div class="col-span-3">
                                <div class="flex items-start">
                                    <div class="flex items-center h-5">
                                        <input id="paid-only" v-model="form.only_paid" type="checkbox"
                                               class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                                    </div>
                                    <div class="ml-3 text-sm">
                                        <label for="paid-only" class="font-medium text-gray-700">Paid plans only?
                                            (Remove free option)</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(product, index) in form.products" :key="index" class="mb-4 mt-8">
                        <span v-for="feature in product.features"
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-orange-100 text-orange-800">{{ feature }}</span>
                            <div class="grid grid-cols-6 gap-2">
                                <div class="col-span-6 sm:col-span-4">
                                    <input type="text" v-model="product.description"
                                           :name="`product_description_${product.id}`"
                                           class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md
                            shadow-sm focus:outline-none focus:ring-blue focus:border-blue-300
                            transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                </div>
                                <div class="col-span-6 sm:col-span-1">
                                    <input type="text" v-model="product.price_formatted"
                                           :name="`product_price_${product.id}`" class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md
                            shadow-sm focus:outline-none focus:ring-blue focus:border-blue-300
                            transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                </div>
                                <div class="col-span-6 sm:col-span-1">
                                    <select v-model="product.currency" :name="`product_currency_${product.id}`"
                                            id="currency" class="mt-1 form-select block w-full py-2 px-3 border border-gray-300 rounded-md
                            shadow-sm focus:outline-none focus:ring-blue focus:border-blue-300
                            transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                        <option v-for="currency in supportedCurrencies" :value="currency">{{ currency.toUpperCase() }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <InputError :message="form.error('products.0.description')" class="mt-2"/>
                        <InputError :message="form.error('products.1.description')" class="mt-2"/>
                        <InputError :message="form.error('products.0.currency')" class="mt-2"/>
                        <InputError :message="form.error('products.1.currency')" class="mt-2"/>
                        <InputError :message="form.error('products.0.price_formatted')" class="mt-2"/>
                        <InputError :message="form.error('products.1.price_formatted')" class="mt-2"/>
                    </div>
                    <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6">
                        <ActionMessage :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </ActionMessage>

                        <Button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            Save
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Button from "@/Jetstream/Button";
    import ActionMessage from "@/Jetstream/ActionMessage";
    import InputError from "@/Jetstream/InputError";
    import InputText from "@/Jobroll/InputText";

    export default {
        name: "EditProducts",
        components: {
            Button,
            ActionMessage,
            InputError,
            InputText
        },
        props: {
            products: Array,
            errors: Object,
            supportedCurrencies: Array
        },
        data() {
            return {
                form: this.$inertia.form({
                    products: this.products,
                    only_paid: this.$page.board.only_paid
                }, {
                    resetOnSuccess: false
                }),
            }
        },
        methods: {
            formattedPrice(amount, currency) {
                return new Intl.NumberFormat('en-US', {style: 'currency', currency}).format(amount / 100)
            },
            submit() {
                this.form.post('/settings/products', {preserveScroll: true});
            }
        }
    }
</script>
